module.exports = __webpack_public_path__ + "img/eye.53efc6ba.svg";